exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".LoadingSpinner__overlay___1MG_t_T2 {\n  z-index: 9999;\n  position: absolute;\n  left: 0;\n  top: 0;\n  background-color: white;\n  width: 100%;\n  height: 100%;\n}\n.LoadingSpinner__overlay___1MG_t_T2.LoadingSpinner__fixed___1ffhgZrD {\n    position: fixed;\n}\n.LoadingSpinner__spinnerContainer___3zCxJvjZ {\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n}\n", ""]);
// Exports
exports.locals = {
	"overlay": "LoadingSpinner__overlay___1MG_t_T2",
	"fixed": "LoadingSpinner__fixed___1ffhgZrD",
	"spinnerContainer": "LoadingSpinner__spinnerContainer___3zCxJvjZ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js??ref--3-oneOf-0-1!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./node_modules/eslint-loader??ref--0!./src/apps/configurator/components/LoadingSpinner.vue?vue&type=style&index=0&lang=scss&module=true&
// module id = jhcO
// module chunks = 3